<template>
    <div class="audits" :class="{loading:loading}">
        <fieldset>
            <legend>History</legend>

            <div class="list-group">
                <a href="javascript://void" class="list-group-item"
                   :class="{'list-group-item-success active': audit.id === listAudit.id}"
                   v-for="listAudit in audits"
                   @click="audit = listAudit">
                    <h5 class="margin-sm-bottom">
                        {{listAudit.created_at | date}}
                        <span v-html="listAudit.typeLabel"></span>
                        <span v-html="listAudit.archivedLabel"></span>
                    </h5>

                    <div class="row">
                        <div class="col-xs-4" v-if="listAudit.displayKey !== null">
                            <dl class="no-margin">
                                <dt>Attribute</dt>
                                <dd class="no-margin">
                                    {{listAudit.displayKey}}
                                </dd>
                            </dl>
                        </div>
                        <div class="col-xs-4" v-if="listAudit.former_value !== null">
                            <dl class="no-margin">
                                <dt>Former Value</dt>
                                <dd class="no-margin">
                                    {{listAudit.former_value}}
                                </dd>
                            </dl>
                        </div>
                        <div class="col-xs-4">
                            <dl class="no-margin">
                                <dt>By</dt>
                                <dd class="no-margin">
                                    <a v-if="listAudit.user" :href="'/users/' + listAudit.user_id">
                                        {{listAudit.user.fullName}}
                                    </a>
                                    <span v-else>System</span>
                                </dd>
                            </dl>
                        </div>
                    </div>

                    <div v-if="audit.id === listAudit.id && listAudit.type === 1">
                        <button type="button" class="btn btn-warning btn-sm" @click="revert(listAudit)"
                                v-if="listAudit.deleted_at === null">
                            Revert
                        </button>
                        <button type="button" class="btn btn-info btn-sm" @click="restore(listAudit)" v-else>
                            Restore
                        </button>
                    </div>
                </a>
            </div>
        </fieldset>
    </div>
</template>

<script>
    export default {
        props: {
            auditableId: {
                type: String,
                required: true
            },

            auditableType: {
                type: String,
                required: true
            },

            auditKey: {
                type: String,
                default: null
            },

            afterSave: {
                default(){
                    return function(){
                        window.location.reload();
                    };
                }
            }
        },

        created(){
            this.init();
        },

        data(){
            return {
                loading: false,

                audits: [],

                audit: {}
            };
        },

        computed: {},

        watch: {},

        filters: {
            title( value ){
                if( _.isString( value ) ){
                    return _.startCase( value );
                }
            }
        },

        methods: {
            /** Address **/
            loadAudits(){
                var url = '/api/audits?archived=archived&' +
                    'auditable_type=' + this.auditableType + '&auditable_id=' + this.auditableId;

                if( this.auditKey ){
                    url += '&key=' + this.auditKey;
                }

                return axios.get( url )
                    .then( ( response ) => {
                        this.$set( this, 'audits', response.data.Audits );
                    } );
            },

            revert( audit ){
                this.loading = true;

                return axios.delete( '/api/audits/' + audit.id )
                    .then( ( result ) => {
                        return this.loadAudits();
                    } )
                    .then( () => {
                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Reverted Change',
                        } );

                        this.afterSave();
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            restore( audit ){
                this.loading = true;

                return axios.put( '/api/audits/' + audit.id + '/restore' )
                    .then( ( result ) => {
                        return this.loadAudits();
                    } )
                    .then( () => {
                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Restored Change',
                        } );

                        this.afterSave();
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            init(){
                this.loading = true;

                this.loadAudits()
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },
        }
    }
</script>
